import { render } from "./MonitorView.vue?vue&type=template&id=349af8ec&scoped=true"
import script from "./MonitorView.vue?vue&type=script&lang=js"
export * from "./MonitorView.vue?vue&type=script&lang=js"

import "./MonitorView.vue?vue&type=style&index=0&id=349af8ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349af8ec"]])

export default __exports__